export default __webpack_public_path__ + "static/media/logo.203f69c4.svg";